import { useState, useEffect, useRef } from "react";
import Navbar from "./Navbar";
import FileBoard from "./FileBoard";
import AutomationList, { AutomationListRefType } from "./AutomationList";
import GeneratedFiles from "./GeneratedFiles"; // Nowy komponent
import "../styles/Documents.css";

export function Documents() {
  const getInitialTab = () => {
    const tab = localStorage.getItem('activeTab');
    if (tab === 'files' || tab === 'automations' || tab === 'generatedFiles') return tab;
    return 'files';
  };
  const [activeTab, setActiveTab] = useState<'files' | 'automations' | 'generatedFiles'>(getInitialTab());
  const [automationSearch, setAutomationSearch] = useState('');
  const automationListRef = useRef<AutomationListRefType>(null);
  const [pendingAutomationJump, setPendingAutomationJump] = useState<{ name: string; folderId: string | null; id?: string } | null>(null);

  const handleTabChange = (tab: 'files' | 'automations' | 'generatedFiles') => {
    setActiveTab(tab);
    localStorage.setItem('activeTab', tab);
    if (tab !== 'automations') {
      setAutomationSearch('');
    }
  };

  useEffect(() => {
    const syncTab = () => {
      const tab = localStorage.getItem('activeTab');
      if (tab === 'files' || tab === 'automations' || tab === 'generatedFiles') {
        setActiveTab(tab);
      } else {
        setActiveTab('files');
      }
    };
    window.addEventListener('storage', syncTab);
    return () => window.removeEventListener('storage', syncTab);
  }, []);

  useEffect(() => {
    if (activeTab === 'automations' && pendingAutomationJump && automationListRef.current) {
      automationListRef.current.jumpToFolderAndSearch(
        pendingAutomationJump.name,
        pendingAutomationJump.folderId,
        pendingAutomationJump.id
      );
      setPendingAutomationJump(null);
    }
  }, [activeTab, pendingAutomationJump]);

  return (
    <div className="dashboard-container">
      <div className="dashboard-content">
        <Navbar activeTab={activeTab} setActiveTab={handleTabChange} />
        <div className="main-content">
          {/* 🔹 Renderowanie odpowiedniego widoku */}
          {activeTab === "files" && (
            <FileBoard
              setActiveTab={handleTabChange}
              setAutomationSearch={setAutomationSearch}
              onJumpToAutomation={(automationName, folderId, automationId) => {
                setPendingAutomationJump({ name: automationName, folderId, id: automationId });
                setActiveTab('automations');
              }}
            />
          )}
          {activeTab === "automations" && (
            <AutomationList ref={automationListRef} automationSearch={automationSearch} setAutomationSearch={setAutomationSearch} />
          )}
          {activeTab === "generatedFiles" && <GeneratedFiles />}
        </div>
      </div>
    </div>
  );
}
